(() => {
  const gate = document.getElementById('uv-age-gate');
  if (!gate) return;
  const key = 'uv-age-v1';
  let state = null;
  try { state = sessionStorage.getItem(key); } catch (_) {}
  const choices = document.getElementById('uv-age-choices');
  const denied = document.getElementById('uv-age-denied');
  const siblings = [...document.body.children].filter(el => el !== gate && !['SCRIPT','STYLE'].includes(el.tagName));
  const originalInert = new Map(siblings.map(el => [el, el.inert]));
  const unlock = () => {
    gate.hidden = true;
    document.documentElement.classList.remove('uv-age-pending');
    siblings.forEach(el => { el.inert = originalInert.get(el); });
    const main = document.getElementById('MainContent');
    if (main) { main.setAttribute('tabindex', '-1'); main.focus({preventScroll:true}); }
  };
  const reject = () => {
    choices.hidden = true;
    document.getElementById('uv-age-copy').hidden = true;
    denied.hidden = false;
    denied.focus();
  };
  if (state === 'adult') {
    unlock();
    if (location.hash) requestAnimationFrame(() => {
      const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) target.scrollIntoView();
    });
    return;
  }
  siblings.forEach(el => { el.inert = true; });
  if (state === 'underage') reject();
  else document.getElementById('uv-age-yes').focus();
  document.getElementById('uv-age-yes').addEventListener('click', () => {
    if (state === 'underage') return;
    state = 'adult';
    try { sessionStorage.setItem(key, state); } catch (_) {}
    unlock();
  });
  document.getElementById('uv-age-no').addEventListener('click', () => {
    state = 'underage';
    try { sessionStorage.setItem(key, state); } catch (_) {}
    reject();
  });
  document.addEventListener('keydown', event => {
    if (gate.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...gate.querySelectorAll('button,a[href]')].filter(el => el.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
})();
